define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_register/validate_register_step/3",

        validation: {
            // signature_3: 'validateSignature',
            consent_3: {
                acceptance: true
            }
        },

        labels:{
            // signature_3: 'Signature',
            consent_3: 'IB Agreement'
        },

        // validateSignature: function(val, attr, computed){
        //     // Check if empty
        //     if("" === val || undefined === val){
        //         return Backbone.Validation.validators.required(val, attr, true, this, computed);
        //     }
        //
        //     var check_val = this.get('first_name') + " " + this.get('last_name');
        //     return Backbone.Validation.validators.equals(val.trim(), attr, check_val.trim(), this, computed);
        // }
    });
});